import { useState, createContext } from "react";
import { ThemeTypes } from "Types/enums";
import { ThemeColor, ThemeContextProps } from "Types/ThemeContextProps";

export const ThemeContext = createContext<ThemeContextProps>({} as ThemeContextProps);

export const ThemeProvider = ({ children }:{children:any}) => {

  const [theme, setTheme] = useState<ThemeColor>(ThemeTypes.LIGHT);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      { children }
    </ThemeContext.Provider>
  )

}